import React from 'react';
import { Link } from 'react-router-dom';
import { I18n } from 'react-redux-i18n';

import ROUTES from '../data/routes';

const NotFoundPage = () => (
  <main>
    <div className="section section-panel">
      <div className="container">
        <div className="box-content">
          <div className="basket cart-status">
            <span className="cart-status-image" style={{ backgroundImage: 'url(/images/erro-404.svg)' }} />
            <p style={{ fontSize: 'x-large' }}>{I18n.t('pageNotFound')}</p>
            <br />
            <br />
            <Link
              to={ROUTES.HOME}
              className="btn btn-outline-secondary"
            >
              {I18n.t('returnHome')}
            </Link>
          </div>
        </div>
      </div>
    </div>
  </main>
);

export default NotFoundPage;
